import React from 'react'
import { observer } from 'mobx-react'
import StatementsTable from '@Components/Tables/RoyaltiesTable/StatementsTable'
import DisabledTable from '@Components/Tables/RoyaltiesTable/DisabledTable'
import { RoyaltiesStatementsContext } from '@Scenes/RightsholderScene/RightsholderRoyaltiesStatements/hooks/useRoyaltiesStatements'
import { useOutletContext } from 'react-router'

const RoyaltiesStatementsTable = () => {
    const { selectedPayee, toggleChecked, filteredRows, deselectAll, selectAll, selectedStatements } =
        useOutletContext<RoyaltiesStatementsContext>()

    const handleToggleAll = () => {
        if (!selectedStatements.length) {
            selectAll()
        } else {
            deselectAll()
        }
    }

    return (
        <>
            {selectedPayee ? (
                <StatementsTable
                    selectedRows={selectedStatements}
                    toggleAll={handleToggleAll}
                    rows={filteredRows}
                    toggleChecked={toggleChecked}
                />
            ) : (
                <>
                    <DisabledTable />
                    <div className="no-payee-selected">
                        <h5>Please select a payee to see statements</h5>
                    </div>
                </>
            )}
        </>
    )
}

export default observer(RoyaltiesStatementsTable)
